import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { ClientsSegmentationRoutes } from '../../../routes/HomeRoutes/ClientsSegmentationRoutes';

export const ClientsSegmentationLayout = () => (
  <SwitchRoute routes={ClientsSegmentationRoutes} />
);
